package com.flowyride.core.fileexport

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

@Composable
actual fun rememberFileExporter(): FileExporter = remember { BrowserDownloadFileExporter() }

/** Triggers a regular browser download. */
private class BrowserDownloadFileExporter : FileExporter {

    override suspend fun export(file: ExportableFile) {
        val blob = Blob(arrayOf(file.content), BlobPropertyBag(type = file.mimeType))
        val url = URL.createObjectURL(blob)
        val anchor = document.createElement("a") as HTMLAnchorElement
        anchor.href = url
        anchor.download = file.fileName
        document.body?.appendChild(anchor)
        anchor.click()
        anchor.remove()
        // Revoking synchronously can cancel the download in some browsers.
        window.setTimeout({ URL.revokeObjectURL(url) }, REVOKE_DELAY_MS)
    }

    private companion object {
        const val REVOKE_DELAY_MS = 10_000
    }
}
